import { KpiCardStaticConfig } from 'app/modules/cleaning/widgets/machine-dashboard/types/MachineDashboard.types';
import { kccThemeConstants } from 'config/theme/kccTheme/kccTheme';

const { PETROL, GRAY_250, BLACK } = kccThemeConstants.COLORS;

export const MACHINE_UTILISATION_STATIC_CONFIG: KpiCardStaticConfig = {
  id: 'machineUtilisation',
  title: 'machineDashboard.machineUtilisation.title',
  tooltip: 'machineDashboard.machineUtilisation.tooltip',
  centerLabel: 'machineDashboard.machineUtilisation.centerLabel',
  listTitle: 'machineDashboard.machineUtilisation.listTitle',
  alertSegmentIndex: 1,
  alertText: 'machineDashboard.machineUtilisation.alertText',
  hintText: 'machineDashboard.machineUtilisation.hintText',
  emptyDescription: 'machineDashboard.machineUtilisation.emptyDescription',
  segmentLabels: [
    { label: 'machineDashboard.machineUtilisation.legendLabel.used', color: PETROL[600] },
    { label: 'machineDashboard.machineUtilisation.legendLabel.notUsed', color: BLACK },
  ],
};

export const KPI_CARD_STATIC_CONFIGS: KpiCardStaticConfig[] = [
  {
    id: 'dataStatus',
    title: 'machineDashboard.dataStatus.title',
    tooltip: 'machineDashboard.dataStatus.tooltip',
    centerLabel: 'machineDashboard.dataStatus.centerLabel',
    listTitle: 'machineDashboard.dataStatus.listTitle',
    alertSegmentIndex: 2,
    alertText: 'machineDashboard.dataStatus.alertText',
    hintText: 'machineDashboard.dataStatus.hintText',
    emptyDescription: 'machineDashboard.dataStatus.emptyDescription',
    segmentLabels: [
      { label: 'machineDashboard.dataStatus.legendLabel.upToDate', color: PETROL[600] },
      { label: 'machineDashboard.dataStatus.legendLabel.oneTo3Days', color: PETROL[200] },
      { label: 'machineDashboard.dataStatus.legendLabel.moreThan3Days', color: BLACK },
      { label: 'machineDashboard.dataStatus.legendLabel.na', color: GRAY_250 },
    ],
  },
  {
    id: 'geofencing',
    title: 'machineDashboard.geofencing.title',
    tooltip: 'machineDashboard.geofencing.tooltip',
    centerLabel: 'machineDashboard.geofencing.centerLabel',
    listTitle: 'machineDashboard.geofencing.listTitle',
    alertSegmentIndex: 2,
    alertText: 'machineDashboard.geofencing.alertText',
    hintText: 'machineDashboard.geofencing.hintText',
    emptyDescription: 'machineDashboard.geofencing.emptyDescription',
    segmentLabels: [
      { label: 'machineDashboard.geofencing.legendLabel.inside', color: PETROL[600] },
      { label: 'machineDashboard.geofencing.legendLabel.notConfigured', color: BLACK },
      { label: 'machineDashboard.geofencing.legendLabel.outside', color: GRAY_250 },
    ],
  },
  {
    id: 'batteryStatus',
    title: 'machineDashboard.batteryStatus.title',
    tooltip: 'machineDashboard.batteryStatus.tooltip',
    centerLabel: 'machineDashboard.batteryStatus.centerLabel',
    listTitle: 'machineDashboard.batteryStatus.listTitle',
    alertSegmentIndex: 1,
    alertText: 'machineDashboard.batteryStatus.alertText',
    hintText: 'machineDashboard.batteryStatus.hintText',
    emptyDescription: 'machineDashboard.batteryStatus.emptyDescription',
    segmentLabels: [
      { label: 'machineDashboard.batteryStatus.legendLabel.normal', color: PETROL[600] },
      { label: 'machineDashboard.batteryStatus.legendLabel.critical', color: BLACK },
    ],
  },
];
